// 🔹 Stylesheets
import './OnboardingTrainer.style.scss';
import './OnboardingTrainer.scss';

// 🔹 React Core
import React from 'react';
import type { FC } from 'react';

// 🔹 Routing
import { Outlet, useLocation } from 'react-router-dom';

// 🔹 Components
import { CustomToaster } from './components/CustomToaster';

export const OnboardingTrainer: FC = () => {
  const location = useLocation();
  const isAuthPage =
    location.pathname.includes('/login') ||
    location.pathname.includes('/signup') ||
    location.pathname.includes('/dashboard');

  return (
    <div className={`onboarding-Trainer ${isAuthPage ? 'no-padding' : ''}`}>
      <CustomToaster />
      <Outlet />
    </div>
  );
};
